// extracted by css-extract-rspack-plugin
export default {"Skeleton":"Skeleton-module__Skeleton___d1oZx","shimmer":"Skeleton-module__shimmer___LvPIT"};